/* DONSTORE Shopify Theme — theme.js */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* Waehrung aus dem Shop lesen, nicht raten.
     Hier stand vorher fest de-DE / EUR – der Warenkorb zeigte Euro
     statt Franken, obwohl der Shop auf CHF laeuft. */
  var SHOP_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF';
  function money(cents) {
    try {
      return (cents / 100).toLocaleString('de-CH', { style: 'currency', currency: SHOP_CURRENCY });
    } catch (e) {
      return SHOP_CURRENCY + ' ' + (cents / 100).toFixed(2);
    }
  }
  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Header scroll shadow ── */
  var header = qs('#ds-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Mobile Nav ── */
  var mobileNav = qs('#ds-mobile-nav');
  var navOverlay = qs('#ds-nav-overlay');
  var menuBtn = qs('.ds-header__menu-btn');
  var navCloseBtn = qs('.ds-mobile-nav__close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (navOverlay) navOverlay.classList.add('is-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (navOverlay) navOverlay.classList.remove('is-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
  if (navCloseBtn) navCloseBtn.addEventListener('click', closeMobileNav);
  if (navOverlay) navOverlay.addEventListener('click', closeMobileNav);

  /* ── Search Drawer ── */
  var searchDrawer = qs('#ds-search-drawer');
  var searchOpen = qs('#ds-search-open');
  var searchClose = qs('#ds-search-close');
  var searchBackdrop = qs('#ds-search-backdrop');
  var searchInput = qs('#ds-search-input');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('is-open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 300);
  }
  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  /* ── Cart Drawer ── */
  var cartDrawer   = qs('#ds-cart-drawer');
  var cartBadge    = qs('#ds-cart-badge');
  var drawerCount  = qs('#ds-drawer-count');
  var drawerTotal  = qs('#ds-drawer-total');
  var drawerBody   = qs('#ds-drawer-body');
  var drawerFooter = qs('#ds-drawer-footer');
  var drawerReco   = qs('#ds-drawer-reco');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderDrawerItems(cart) {
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="ds-cart-drawer__empty"><p>Dein Warenkorb ist leer.</p><a href="/collections/all" class="ds-btn ds-btn--dark">Weiter shoppen →</a></div>';
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (item) {
      var key = escHtml(item.key);
      return '<div class="ds-cart-drawer__item" data-line-key="' + key + '">' +
        '<a href="' + item.url + '">' +
          '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" width="60" height="60" loading="lazy">' +
        '</a>' +
        '<div class="ds-cart-drawer__item-info">' +
          '<a href="' + item.url + '">' + escHtml(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="ds-cart-drawer__variant">' + escHtml(item.variant_title) + '</span>' : '') +
          '<div class="ds-cart-drawer__item-row"><span>' + money(item.final_line_price) + '</span></div>' +
          '<div class="ds-drawer-line">' +
            '<div class="ds-drawer-qty">' +
              '<button type="button" class="ds-drawer-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Menge verringern">−</button>' +
              '<span class="ds-drawer-qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="ds-drawer-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<button type="button" class="ds-drawer-remove" data-key="' + key + '">Entfernen</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* ── Cross-Sell: erstes Produkt, das noch nicht im Warenkorb liegt ── */
  var recoCache = null;
  function renderReco(cart) {
    if (!drawerReco) return;
    if (cart.item_count === 0) { drawerReco.hidden = true; return; }

    var inCart = cart.items.map(function (i) { return i.product_id; });

    function paint(list) {
      var p = (list || []).find(function (prod) {
        return inCart.indexOf(prod.id) === -1 &&
               prod.variants.some(function (v) { return v.available; });
      });
      if (!p) { drawerReco.hidden = true; return; }
      var v = p.variants.find(function (x) { return x.available; });
      var img = (p.images && p.images[0]) ? p.images[0] : (p.featured_image || '');
      var src = typeof img === 'string' ? img : (img.src || '');
      drawerReco.hidden = false;
      drawerReco.innerHTML =
        '<p class="ds-drawer-reco__kicker">Passt dazu</p>' +
        '<div class="ds-drawer-reco__card">' +
          (src ? '<a href="/products/' + p.handle + '"><img class="ds-drawer-reco__img" src="' + src + '" alt="' + escHtml(p.title) + '" loading="lazy"></a>' : '') +
          '<div class="ds-drawer-reco__info">' +
            '<p class="ds-drawer-reco__name">' + escHtml(p.title) + '</p>' +
            '<p class="ds-drawer-reco__price">' + money(v.price) + '</p>' +
          '</div>' +
          '<button type="button" class="ds-drawer-reco__add" data-variant-id="' + v.id + '">Dazu</button>' +
        '</div>';
    }

    if (recoCache) { paint(recoCache); return; }

    var seed = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + seed + '&limit=4&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        recoCache = (d && d.products) || [];
        paint(recoCache);
      })
      .catch(function () { drawerReco.hidden = true; });
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        if (cartBadge) {
          cartBadge.textContent = count;
          cartBadge.style.display = count > 0 ? '' : 'none';
        }
        if (drawerCount) drawerCount.textContent = '(' + count + ')';
        if (drawerTotal) drawerTotal.textContent = money(cart.total_price);
        if (drawerFooter) drawerFooter.hidden = count === 0;
        renderDrawerItems(cart);
        renderReco(cart);
        return cart;
      })
      .catch(function () {});
  }

  function changeLine(key, qty, rowEl) {
    if (rowEl) rowEl.classList.add('is-busy');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartDrawer(); })
      .catch(function () { if (rowEl) rowEl.classList.remove('is-busy'); });
  }

  /* Alles delegiert – die Buttons entstehen erst beim Rendern */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#ds-cart-open, .ds-cart-open')) { openCart(); return; }
    if (e.target.closest('.ds-cart-drawer__close')) { closeCart(); return; }
    if (e.target.closest('.ds-cart-drawer__backdrop')) { closeCart(); return; }

    var qBtn = e.target.closest('.ds-drawer-qty-btn');
    if (qBtn) {
      changeLine(qBtn.dataset.key, parseInt(qBtn.dataset.qty, 10), qBtn.closest('.ds-cart-drawer__item'));
      return;
    }

    var rBtn = e.target.closest('.ds-drawer-remove');
    if (rBtn) {
      changeLine(rBtn.dataset.key, 0, rBtn.closest('.ds-cart-drawer__item'));
      return;
    }

    var aBtn = e.target.closest('.ds-drawer-reco__add');
    if (aBtn) {
      aBtn.disabled = true;
      var orig = aBtn.textContent;
      aBtn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(aBtn.dataset.variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { recoCache = null; return refreshCartDrawer(); })
        .catch(function () { aBtn.disabled = false; aBtn.textContent = orig; });
      return;
    }
  });

  /* Beim Laden einmal synchronisieren – Shopify liefert Seiten gecached aus */
  refreshCartDrawer();

  /* ── Add to Cart (Produktseite) ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item.status === 422 || item.errors) {
          alert(item.description || 'Fehler beim Hinzufügen');
          if (btn) { btn.disabled = false; btn.textContent = origText; }
          return;
        }
        if (btn) { btn.textContent = 'Hinzugefügt ✓'; }
        recoCache = null;
        /* Erst aktualisieren, DANN oeffnen – sonst blitzt der leere Zustand auf */
        return refreshCartDrawer().then(function () {
          openCart();
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = origText; }
          }, 600);
        });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = origText; }
        alert('Fehler beim Hinzufügen.');
      });
  });

  /* ── Qty buttons (Warenkorbseite / Produktseite) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ds-qty-btn');
    if (!btn) return;
    var wrap = btn.closest('.ds-qty-wrap');
    var input = wrap && wrap.querySelector('.ds-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var delta = btn.dataset.delta === '-1' ? -1 : 1;
    var min = parseInt(input.min, 10) || 1;
    input.value = Math.max(min, val + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Warenkorbseite: Menge ── */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('.ds-cart-qty-input')) return;
    var key = input.dataset.key;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(input.value, 10) })
    }).then(function (r) { return r.json(); }).then(function () { location.reload(); });
  });

  /* ── Warenkorbseite: Entfernen ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ds-cart-item__remove');
    if (!btn) return;
    var key = btn.dataset.key;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { location.reload(); });
  });

  /* ── FAQ Accordion ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ds-faq__question');
    if (!btn) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var answer = btn.nextElementSibling;
    if (!answer) return;
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    answer.hidden = isOpen;
  });

  /* ── Produkt-Details Accordion ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ds-details-btn');
    if (!btn) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var content = btn.nextElementSibling;
    if (!content) return;
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    content.hidden = isOpen;
  });

  /* ── Produktbild-Galerie ── */
  var mainImgEl = qs('.ds-product-page__main-img img');
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.ds-product-page__thumb');
    if (!thumb || !mainImgEl) return;
    if (thumb.dataset.src) mainImgEl.src = thumb.dataset.src;
    if (thumb.dataset.srcset) mainImgEl.srcset = thumb.dataset.srcset;
    qsa('.ds-product-page__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ── Variantenauswahl ── */
  var variantInput = qs('#variant-id');
  if (variantInput) {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.ds-option-pill input[type="radio"]')) return;
      updateSelectedVariant();
    });

    function updateSelectedVariant() {
      var selected = {};
      qsa('.ds-option-pill input[type="radio"]:checked').forEach(function (r) { selected[r.name] = r.value; });
      var variants = window.__dsVariants || [];
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected['option' + (i + 1)] === opt; });
      });
      if (!match) return;
      variantInput.value = match.id;
      var priceEl = qs('.ds-product-page__price');
      var compareEl = qs('.ds-product-page__compare');
      var addBtn = qs('.ds-product-page__add-btn');
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (match.featured_image && mainImgEl) mainImgEl.src = match.featured_image.src;
    }
  }

  /* ── Kundenkonto: Adressformular ── */
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-toggle-address]');
    if (!toggleBtn) return;
    var form = qs('#' + toggleBtn.dataset.toggleAddress);
    if (form) form.classList.toggle('is-open');
  });

  document.addEventListener('click', function (e) {
    var deleteBtn = e.target.closest('[data-confirm-delete]');
    if (!deleteBtn) return;
    if (!confirm('Adresse wirklich löschen?')) e.preventDefault();
  });

  /* ── Passwort anzeigen ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-password-toggle]');
    if (!toggle) return;
    var input = qs('#' + toggle.dataset.passwordToggle);
    if (!input) return;
    var show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    toggle.textContent = show ? 'Verbergen' : 'Anzeigen';
  });

  /* ── Escape schliesst Drawer ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeSearch();
    closeMobileNav();
  });

  /* ── Produktempfehlungen (Produktseite) ── */
  var recoSection = qs('[data-recommendations]');
  if (recoSection) {
    var productId = recoSection.dataset.productId;
    var recoGrid = qs('.ds-recommendations__grid', recoSection);
    if (productId && recoGrid) {
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) { recoSection.style.display = 'none'; return; }
          recoGrid.innerHTML = data.products.map(function (p) {
            var img = p.images[0];
            var price = money(p.variants[0].price);
            var compare = p.variants[0].compare_at_price;
            return '<a class="ds-product-card" href="/products/' + p.handle + '">' +
              '<div class="ds-product-card__img-wrap">' +
                (img ? '<img class="ds-product-card__img" src="' + img.src + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="ds-product-card__info">' +
                '<p class="ds-product-card__name">' + escHtml(p.title) + '</p>' +
                '<div class="ds-product-card__price-row">' +
                  '<div class="ds-product-card__prices">' +
                    '<span class="ds-product-card__price">' + price + '</span>' +
                    (compare && compare > p.variants[0].price ? '<span class="ds-product-card__compare">' + money(compare) + '</span>' : '') +
                  '</div>' +
                  '<span class="ds-product-card__cta">Kaufen →</span>' +
                '</div>' +
              '</div>' +
            '</a>';
          }).join('');
        })
        .catch(function () { recoSection.style.display = 'none'; });
    }
  }

  /* ── Laufband pausiert bei Hover ── */
  var marqueeTrack = qs('.ds-marquee__track');
  if (marqueeTrack) {
    marqueeTrack.parentElement.addEventListener('mouseenter', function () {
      marqueeTrack.style.animationPlayState = 'paused';
    });
    marqueeTrack.parentElement.addEventListener('mouseleave', function () {
      marqueeTrack.style.animationPlayState = 'running';
    });
  }

})();
